export enum PaymentDictionaryActions {
  RequestPaymentDictionary = 'Request data for types of payment dictionaries',
  PaymentDictionaryAccepted = 'Data for types of payment dictionaries accepted',
  PaymentDictionaryRejected = 'Data for types of payment dictionaries rejected',
  AddPayment = 'addPayment',
  DeletePayment = 'delete payment',
  RequestTaxes = 'Request Taxes',
  TaxDictionaryAccepted = 'Taxes accepted',
  SaveTaxes = 'Save taxes',
  AddTax = 'add taxes',
  RequestInvoiceSetting = 'fetch invoice settings',
  SaveInvoiceSetting = 'save invoice settings',
  AcceptedInvoiceSettings = 'accept invoice settings',
  RequestDefaultServices = 'request default services',
  RequestServices = 'request services',
  SaveServices = 'save services',
  SaveDefaultServices = 'save default services',
  AcceptedDefaultServices = 'accept default services',
  AcceptedServices = 'accept services',
  SaveServicesForm = 'save services form',
  SavePrepayment = 'save prepayment form',
  AcceptedPrepayment = 'AcceptedPrepayment',
  SavePaymentMethod = 'save payment actions',
  PaymentMethodError = 'error on saving payment method',
  AcceptedPaymentMethod = 'accept payment method',
  RequestPaymentMethod = 'request payment method',
  CreateStripeAccount = 'create stripe account',
  CompleteStripeAccount = 'complete stripe account',
}
